import { FetchState } from 'src/enums/FetchState';

import { fetchRequest } from 'src/utils/fetchRequest';

export async function favouriteUpdate(itemId: string, isFavourite?: boolean): Promise<FetchState> {
	const slug = isFavourite ? process.env.NEXT_PUBLIC_SITECORE_FAVOURITE_UNFAVOURITE : process.env.NEXT_PUBLIC_SITECORE_FAVOURITE_FAVOURITE;
	const applicationParams = 'applicationId=' + process.env.NEXT_PUBLIC_FAVOURITES_APPLICATIONID;
	const favouriteItemId = 'favouriteItemId=' + itemId;
	const endpoint = `${process.env.NEXT_PUBLIC_SITECORE_FAVOURITE}${slug}?${applicationParams}&${favouriteItemId}`;

	try {
		const response = await fetchRequest(endpoint, {});

		if (!response.ok) {
			throw response.statusText;
		}

		return FetchState.SUCCESS;
	} catch (error) {
		return FetchState.ERROR;
	}
}
